import React from "react"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import get from "lodash/get"
import Layout from "../common/layout"
import Footer from "../common/footer"
import Subscribe from "../components/subscribe/"
import Cards from "../components/cards/"
import { message } from "antd"
import FeaturedGroup from "../components/featuredGroups/"
import "../assets/styles/landingPages.scss"
import white_logo from "../assets/images/logo.svg"
import HelmetScript from "../common/helmetScripts"
function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

class SinglePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formSuccess: false,
    }
  }

  handleChange = e => {
    const post = get(this.props, "data.contentfulSinglePages")
    this.setState({
      page_title: post && post.title && post.title,
      [e.target.name]: e.target.value,
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    const form = e.target
    const post = get(this.props, "data.contentfulSinglePages")
    this.setState({
      page_title: post && post.title && post.title,
    })
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        ...this.state,
      }),
    })
      .then(res => {
        // message.success("Thanks for contact us.")
        var form = document.getElementById("landingpage")
        form.reset()
        this.setState({
          formSuccess: true,
        })
        var now = new Date()
        var time = now.getTime()
        var expireTime = time + 3600 * 1000 * 24 * 365 * 2
        now.setTime(expireTime)
        var formName = document.getElementById("landingpage").name
        localStorage.setItem("formName", formName)
        localStorage.setItem("formData", JSON.stringify(this.state))
        document.cookie =
          `sl_companyName=${this.state.company} ; expires=` +
          now.toGMTString() +
          `;path=/;`
        document.cookie =
          `sl_userName=${this.state.full_name} ; expires=` +
          now.toGMTString() +
          `;path=/;`
        setTimeout(function() {
          window.location.reload()
        }, 800)
      })
      .catch(error => alert(error))
  }
  render() {
    const post = get(this.props, "data.contentfulSinglePages")
    const cards = get(this, "props.data.allContentfulCardGroup.nodes")
    let home01 = cards.find(item => {
      return item.cardPosition === "Home_01"
    })
    const { formSuccess } = this.state
    return (
      <Layout location={this.props.location} customClass="lpCustom">
        <div className="landing-navbar">
          <div className="container">
            <div className="logo">
              <a href="/">
                <img src={white_logo} alt="Logo" />
                <span>Swiftlane</span>
              </a>
            </div>
          </div>
        </div>
        <HelmetScript />
        <Helmet title={post ? post.title : ""}>
          <html lang="en" />
          <meta
            name="description"
            content={post ? post.description : ""}
          ></meta>
          <meta name="keywords" content={post ? post.searchKeywords : ""} />
        </Helmet>
        <div className="landing-pages">
          <div
            className={
              post && post.twilioUrl ? "hero-section video" : "hero-section"
            }
            style={{
              backgroundImage: `url(${post &&
                post.background &&
                post.background.file &&
                post.background.file.url})`,
            }}
          >
            <div className="container">
              <div className="left">
                <h1>{post && post.title}</h1>
                <p>{post && post.description}</p>
                <div className="twilio">
                  {post && post.twilioUrl ? (
                    <>
                      <p>Watch how Swiftlane can secure your office place.</p>
                      <iframe
                        src={post.twilioUrl}
                        width="614"
                        height="340"
                      ></iframe>
                    </>
                  ) : null}
                </div>
              </div>
              <div className="right">
                {!formSuccess ? (
                  <div className="form">
                    <form
                      name="LandingPage"
                      method="POST"
                      id="landingpage"
                      data-netlify="true"
                      action="/"
                      data-netlify-honeypot="bot-field"
                      onSubmit={this.handleSubmit}
                    >
                      <h2>{post && post.formTitle}</h2>
                      <h4>{post && post.formDescription}</h4>
                      <input type="hidden" name="form-name" value="Webinar" />
                      <p hidden>
                        <label>
                          Don’t fill this out:
                          <input
                            name="bot-field"
                            onChange={this.handleChange}
                          />
                        </label>
                      </p>
                      <div className="form-group invisible-field">
                        <input
                          type="text"
                          name="page_title"
                          value={post && post.title}
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          name="full_name"
                          placeholder="Full Name"
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="email"
                          name="email"
                          placeholder="Work Email"
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          name="company"
                          onChange={this.handleChange}
                          placeholder="Company"
                        />
                      </div>
                      <button className="ant-btn ant-btn-primary" type="submit">
                        Get in touch
                      </button>
                    </form>
                  </div>
                ) : (
                  <div className="success-message">
                    <p>Sent! We will be in touch shortly.</p>
                  </div>
                )}
                <div className="call-us">
                  Or give us a call
                  <b>833-607-9438</b>
                </div>
              </div>
            </div>
          </div>

          <div className="home-content container">
            {/* end of box */}
            {post && post.featureGroups1
              ? post.featureGroups1.map((item, index) => {
                  return item.featureGroups.map((item, index) => {
                    return (
                      <FeaturedGroup
                        key={index}
                        buttonUrl={item.buttonLink}
                        buttonText={item.buttonText}
                        descriptions={item.descriptions}
                        title={item.header}
                        position={item.imagePosition}
                        img={item.featurePhoto}
                      />
                    )
                  })
                })
              : null}
          </div>

          {/* Feature Grid */}
          {post && post.cards && post.cards ? (
            <Cards
              classType={post.cards.cardType}
              title={post.cards.cardTitle}
              cardList={post.cards.cardList}
            />
          ) : null}

          <div className="home-content container">
            {/* end of box */}
            {post && post.featureGroups2
              ? post.featureGroups2.map((item, index) => {
                  return item.featureGroups.map((item, index) => {
                    return (
                      <FeaturedGroup
                        key={index}
                        buttonUrl={item.buttonLink}
                        buttonText={item.buttonText}
                        descriptions={item.descriptions}
                        title={item.header}
                        position={item.imagePosition}
                        img={item.featurePhoto}
                      />
                    )
                  })
                })
              : null}
          </div>

          {post && post.cardGroups2 && post.cardGroups2
            ? post.cardGroups2.map(item => (
                <Cards
                  classType={item.cardType}
                  title={item.cardTitle}
                  cardList={item.cardList}
                />
              ))
            : null}
        </div>
        <Subscribe location={this.props.location} />
        <Footer />
      </Layout>
    )
  }
}

export default SinglePage

export const pageQuery = graphql`
  query LandingPostsBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulCardGroup {
      nodes {
        backgroundImage {
          file {
            url
          }
        }
        cardTitle
        cardType
        cardPosition
        cardDescriptions {
          cardDescriptions
        }
        cardList {
          cardTitle
          cardLink
          cardDescriptions {
            childMarkdownRemark {
              html
            }
          }
          photoSize
          cardIcon {
            fixed {
              src
            }
          }
        }
      }
    }
    contentfulSinglePages(slug: { eq: $slug }) {
      id
      slug
      title
      twilioUrl
      formTitle
      formDescription
      description
      cards {
        cardPosition
        cardTitle
        cardType
        cardList {
          cardTitle
          cardLink
          cardDescriptions {
            childMarkdownRemark {
              html
            }
          }
          photoSize
          cardIcon {
            fixed {
              src
            }
          }
        }
      }
      cardGroups2 {
        cardPosition
        cardTitle
        cardType
        cardList {
          cardTitle
          cardLink
          cardDescriptions {
            childMarkdownRemark {
              html
            }
          }
          photoSize
          cardIcon {
            fixed {
              src
            }
          }
        }
      }
      featureGroups1 {
        name
        sectionHeader
        featureGroups {
          buttonLink
          buttonText
          descriptions {
            childMarkdownRemark {
              html
            }
          }
          header
          imagePosition
          featurePhoto {
            file {
              url
            }
          }
        }
      }
      featureGroups2 {
        name
        sectionHeader
        featureGroups {
          buttonLink
          buttonText
          descriptions {
            childMarkdownRemark {
              html
            }
          }
          header
          imagePosition
          featurePhoto {
            file {
              url
            }
          }
        }
      }
      background {
        file {
          url
        }
      }
    }
  }
`
